export const SORTING = {
  bestMatch: {
    value: 'bestMatch',
    key: 'search.filter_header.sorting.best_match'
  },
  bestPrice: {
    value: 'bestPrice',
    key: 'search.filter_header.sorting.best_price'
  },
  recentlyListed: {
    value: 'recentlyListed',
    key: 'search.filter_header.sorting.recently_published'
  }
};

export const DEFAULT_SORTING = SORTING.bestMatch.value;

export const DEFAULT_FILTERS = {
  'move-in': '',
  'move-out': '',
  flexibleMoveIn: 1,
  flexibleMoveOut: 1,
  'features[]': [],
  'type[]': [],
  'topology[]': [],
  'bathrooms[]': [],
  bed: '',
  budget: '',
  poi: '',
  sortBy: DEFAULT_SORTING,
  noDeposit: 0,
  instantBooking: 0,
  superLister: 0,
  verified: 0,
  'ids[]': [],
  'areaId[]': [],
  page: 1,
  poiLat: null,
  poiLng: null
};

export default {
  SORTING,
  DEFAULT_SORTING,
  DEFAULT_FILTERS
};
